module.exports = __webpack_public_path__ + "beb19db553c96f9ab46c768cada1ec2a.MP3";